module.exports = __webpack_public_path__ + "static/img/ai-and-the-future-vishwa-thumb.57d669de.jpg";